export default __webpack_public_path__ + "static/media/Caret Left.53b020e7.svg";